:host {
  display: contents;
}

.droppable-area {
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  border: unset;
  color: unset;
  inset-block: var(--ch-flexible-layout-drop-area-block-start) var(--ch-flexible-layout-drop-area-block-end);
  left: var(--ch-flexible-layout-drop-area-inline-start);
  right: var(--ch-flexible-layout-drop-area-inline-end);
  background-color: color-mix(in srgb, currentColor 15%, transparent);
  transition: inset 150ms ease-in-out;
  pointer-events: none;
}